import React from 'react';
import { StyledLink } from './style'

const LinkButton = ({ link, children, disabled, position }) => (
    <StyledLink position={position} disabled={ disabled } to={link}>{children}</StyledLink>
)

export default LinkButton